import React from 'react';
import ReportingPage from '../../../../projectInfo/tabs/ReportingTab/ReportingPage';

interface GuidelineInfo {
    readonly id?: number;
    readonly name?: string;
}

interface Props {
    readonly guidelineInfo?: GuidelineInfo | null;
}

const ReportingTab: React.FC<Props> = ({ guidelineInfo }) => (
    <ReportingPage projectInfo={guidelineInfo} type="liveGuideline" />
);

export default ReportingTab;
